import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import {
  IPKActivationException,
  IPKActivationExceptionAddRequest,
  IPKActivationExceptionDeleteRequest,
  IPKActivationExceptionStatusRequest,
} from '../models/model'

export class GetPKActivationExceptionsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/getPKActivationExceptions',
      requesterInfo,
    })
  }

  public async getPKActivationExceptions(): Promise<IPKActivationException[]> {
    return await this.getAsync<IPKActivationException[]>()
  }
}

export class AddPKActivationExceptionApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/addPKActivationException',
      requesterInfo,
    })
  }

  public async addPKActivationException(req: IPKActivationExceptionAddRequest): Promise<number> {
    return await this.postAsync<number>(req)
  }
}

export class SetPKActivationExceptionStatusApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/setPKActivationExceptionStatus',
      requesterInfo,
    })
  }

  public async setPKActivationExceptionStatus(req: IPKActivationExceptionStatusRequest): Promise<boolean> {
    return await this.postAsync<boolean>(req)
  }
}

export class DeletePKActivationExceptionApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/deletePKActivationException',
      requesterInfo,
    })
  }

  public async deletePKActivationException(req: IPKActivationExceptionDeleteRequest): Promise<boolean> {
    return await this.postAsync<boolean>(req)
  }
}
